var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import APSelect from '../common/APSelect/APSelect';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import './WhiteListedWithdrawAddressSelect.css';
var baseClasses = getBEMClasses('send-address__select');
var WhiteListedWithdrawAddressSelect = function (_React$Component) {
  _inherits(WhiteListedWithdrawAddressSelect, _React$Component);
  function WhiteListedWithdrawAddressSelect() {
    _classCallCheck(this, WhiteListedWithdrawAddressSelect);
    return _possibleConstructorReturn(this, (WhiteListedWithdrawAddressSelect.__proto__ || Object.getPrototypeOf(WhiteListedWithdrawAddressSelect)).apply(this, arguments));
  }
  _createClass(WhiteListedWithdrawAddressSelect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.fetchAccountWithdrawInfos();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isLoading && !this.props.isLoading) {
        if (this.props.options.length === 2) {
          var AccountWithdrawInfoId = this.props.options[1].value;
          this.props.resetBankField(AccountWithdrawInfoId);
          this.props.onSelect(AccountWithdrawInfoId);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      return React.createElement(APSelect, {
        name: this.props.name,
        customClass: baseClasses(),
        label: this.context.t(this.props.label),
        onSelect: function onSelect(bank) {
          return _this2.props.onSelect(bank);
        },
        options: this.props.options
      });
    }
  }]);
  return WhiteListedWithdrawAddressSelect;
}(React.Component);
WhiteListedWithdrawAddressSelect.contextTypes = {
  t: PropTypes.func.isRequired
};
WhiteListedWithdrawAddressSelect.propTypes = {
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  name: PropTypes.string
};
WhiteListedWithdrawAddressSelect.defaultProps = {
  name: 'ExternalAddress',
  label: 'External Address'
};
export default WhiteListedWithdrawAddressSelect;